var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cbtn"},[_c('div',{staticClass:"b-title NormalSmSize-bold"},[_vm._v(_vm._s(_vm.btitle))]),_c('div',{attrs:{"id":"cb1"}}),_c('div',{attrs:{"id":"cb2"}})])}
var staticRenderFns = []

export { render, staticRenderFns }